<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="特定商業交易法" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">營運公司名稱</span>
            <span class="text">零地有限公司</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表人</span>
            <span class="text">成田優樹</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">公司註冊地址/營業辦公地址</span>
            <span class="text">邮编：330-0854</span>
            <span class="text">埼玉县埼玉市大宫区樱木町1丁目195‑1</span>
            <span class="text">大宫索拉米奇KOZ4楼</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">電話號碼</span>
            <span class="text">050-1724-5360</span>
            <span class="text">(*接待時間：平日 10:00-17:00)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">電子郵件</span>
            <span class="text">支援@xeroplace.jp</span>
            <span class="text">*如有疑問，請使用網站上的聊天室。原則上我們會在2個工作天內回覆。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">價格</span>
            <span class="text">每個產品的顯示</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">產品價格以外的必要費用</span>
            <span class="text">使用本公司提供的服務的設備相關費用、網路連線費、資料包通訊費、消費稅、支付轉帳費用。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">交貨時間</span>
            <span class="text">受理申請時</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">銷售數量</span>
            <span class="text">沒有特定的規格。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">付款方式</span>
            <span class="text">我們接受信用卡、PayPal 和 Amazon Pay。</span>
            <span class="text">*付款後，我們不接受因客戶方便而取消訂單。感謝您的體諒。</span>
            <span class="text">若逾期未付款，則自動取消。</span>
            <span class="text">付款期限</span>
            <span class="text">信用卡：基於信用卡公司的條款和條件。</span>
            <span class="text">PayPal：基於 PayPal 條款。</span>
            <span class="text">Amazonpay：基於 Amazonpay 條款與條件。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">退貨政策和期限</span>
            <span class="text">一般來說，我們不接受退貨或換貨，但如果我們有 100% 的過錯，我們會做出回應。</span>
            <span class="text">但是，以下情況我們無法應付。感謝您的體諒。</span>
            <span class="text">如果物品在運送過程中遺失或損壞</span>
            <span class="text">如果未開封的物品如BOX等沒有錄影。</span>
            <span class="text">*我們在檢查再收縮產品時要特別小心。</span>
            <span class="text">如果產品到達後已超過 10 天</span>
            <span class="text">如果您發現PSA等鑑定品有刮痕等，並以此為理由接受您的換貨或退貨要求。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">古董商營業執照</span>
            <span class="text">沒有431370066203</span>
            <span class="text">零地有限公司</span>
            <span class="text">埼玉県公安委員會</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
